export default __webpack_public_path__ + "static/media/car-gas.a913a855.jpg";